import { TVideoType } from '../../../../common/videoUtils';
import { ILiveEventSummary, LiveEventMode } from '../../../../types/eventTypes';

export enum LiveMastheadComponents {
  Event = 'event',
  Coverage = 'coverage',
  Video = 'video'
}

export interface ILiveEventMastheadProps {
  data: ILiveEventSummary;
  onRefresh?: () => void;
  isRefreshing?: boolean;
  liveEventMode: LiveEventMode;
  isRefreshPaused?: boolean;
}

export type TLiveMastheadComponentConfig =
  | {
      component: LiveMastheadComponents.Coverage;
    }
  | {
      component: LiveMastheadComponents.Video;
    }
  | {
      component: LiveMastheadComponents.Event;
      timer: 'default' | 'always' | 'never';
    };

export type TMastheadLayoutConfig = TLiveMastheadComponentConfig[][];

export interface ILiveEventVideoConfig {
  videoId: string;
  videoType: TVideoType;
  thumbnail: boolean;
  autoplay: boolean;
  disabled?: boolean;
}
